import React from 'react';
import { useTranslation } from 'react-i18next';
import { countries } from '../../constants/countries';

const CountrySelect = ({ 
  value, 
  onChange, 
  placeholder, 
  required = false,
  disabled = false,
  name = "COUNTRYREGIONID"
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Sort countries by name in current language
  const sortedCountries = [...countries].sort((a, b) => {
    const nameA = currentLanguage === 'it' ? a.name_it : a.name_en;
    const nameB = currentLanguage === 'it' ? b.name_it : b.name_en;
    return nameA.localeCompare(nameB);
  });

  // Move Italy to the top if current language is Italian
  let finalCountries = sortedCountries;
  if (currentLanguage === 'it') {
    const italyIndex = sortedCountries.findIndex(country => country.code === 'ITA');
    if (italyIndex > -1) {
      const italy = sortedCountries.splice(italyIndex, 1)[0];
      finalCountries = [italy, ...sortedCountries];
    }
  }

  return (
    <select
      value={value || ''}
      onChange={onChange}
      name={name}
      required={required}
      disabled={disabled}
      style={{ 
        width: '100%',
        padding: '8px',
        border: '1px solid #ddd',
        borderRadius: '4px',
        fontSize: '14px'
      }}
    >
      <option value="">{placeholder}</option>
      {finalCountries.map((country) => (
        <option key={country.code} value={country.code}>
          {currentLanguage === 'it' ? country.name_it : country.name_en}
        </option>
      ))}
    </select>
  );
};

export default CountrySelect;